var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`cover ${_vm.visible ? 'visible' : ''}`,style:({ zIndex: _vm.index })},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }